module.exports = {"data":{"settingsYaml":{"siteTitle":"TRH Equine Vets","siteDescription":"","headerScripts":"<!-- Add your analytics scripts / verification meta here -->","socialMediaCard":{"image":"/images/uploads/open_graph.jpg"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 363
// module chunks = 60335399758886 114276838955818